// The colours a folder can have. The ids are what the API stores (Folder::COLORS);
// no colour means the default gray folder. Hexes are Bootstrap's own, plus the brand blue.
export const FOLDER_COLORS = [
  { id: 'red', label: 'Red', hex: '#dc3545' },
  { id: 'orange', label: 'Orange', hex: '#fd7e14' },
  { id: 'yellow', label: 'Yellow', hex: '#e0a800' },
  { id: 'green', label: 'Green', hex: '#28a745' },
  { id: 'teal', label: 'Teal', hex: '#17a2b8' },
  { id: 'blue', label: 'Blue', hex: '#006cff' },
  { id: 'purple', label: 'Purple', hex: '#6f42c1' },
  { id: 'pink', label: 'Pink', hex: '#e83e8c' },
]

export function folderColorHex(id) {
  const match = FOLDER_COLORS.find((color) => color.id === id)
  return match ? match.hex : null
}

// Inline style for a folder icon; empty for the default gray.
export function folderIconStyle(id) {
  const hex = folderColorHex(id)
  return hex ? { color: hex } : {}
}

// Inline style for the guide line beside a folder row; empty for the default gray.
export function folderLineStyle(id) {
  const hex = folderColorHex(id)
  return hex ? { borderLeftColor: hex } : {}
}
